import { registerWidget } from '../registry';
import { startWidget } from './start';
import { sayWidget } from './say';
import { gatherWidget } from './gather';
import { transferWidget } from './transfer';
import { playWidget } from './play';
import { conditionalWidget } from './conditional';
import { httpRequestWidget } from './http-request';
import { getCustomerIdWidget } from './get-customer-id';
import { aiAgentWidget } from './ai-agent';
import { hoursOfOperationWidget } from './hours-of-operation';
import { recordingWidget } from './recording';
import { getLanguagePreferenceWidget } from './get-language-preference';
import { transferToQueueWidget } from './transfer-to-queue';
import { transferToAgentWidget } from './transfer-to-agent';
import { voicemailWidget } from './voicemail';

export { startWidget } from './start';
export { sayWidget } from './say';
export { gatherWidget } from './gather';
export { transferWidget } from './transfer';
export { playWidget } from './play';
export { conditionalWidget } from './conditional';
export { httpRequestWidget } from './http-request';
export { getCustomerIdWidget } from './get-customer-id';
export { aiAgentWidget } from './ai-agent';
export { hoursOfOperationWidget } from './hours-of-operation';
export { recordingWidget } from './recording';
export { getLanguagePreferenceWidget } from './get-language-preference';
export { transferToQueueWidget } from './transfer-to-queue';
export { transferToAgentWidget } from './transfer-to-agent';
export { voicemailWidget } from './voicemail';

export function registerAllWidgets() {
  registerWidget(startWidget);
  registerWidget(sayWidget);
  registerWidget(gatherWidget);
  registerWidget(transferWidget);
  registerWidget(playWidget);
  registerWidget(conditionalWidget);
  registerWidget(httpRequestWidget);
  registerWidget(getCustomerIdWidget);
  registerWidget(aiAgentWidget);
  registerWidget(hoursOfOperationWidget);
  registerWidget(recordingWidget);
  registerWidget(getLanguagePreferenceWidget);
  registerWidget(transferToQueueWidget);
  registerWidget(transferToAgentWidget);
  registerWidget(voicemailWidget);
}

registerAllWidgets();
